import React from 'react';
import { SectionCard } from '../common/SectionCard';
import { formatCompact, formatDate } from '../../utils/format';
import { cn } from '../../utils/cn';
import type { ChannelPlacement, ChannelState } from '../../types/outreach';
const states: {
  id: ChannelState;
  label: string;
  className: string;
}[] = [{
  id: 'queued',
  label: 'Queued',
  className: 'border-border bg-muted'
}, {
  id: 'scheduled',
  label: 'Scheduled',
  className: 'border-border bg-card'
}, {
  id: 'live',
  label: 'Live',
  className: 'border-uae-leaf/30 bg-uae-leaf/5'
}, {
  id: 'delivered',
  label: 'Delivered',
  className: 'border-uae-green/25 bg-uae-green/5'
}];
export function ChannelBoard({
  placements
}: {
  placements: ChannelPlacement[];
}) {
  return <SectionCard title="Ecosystem channel distribution" description="Placements across UAE government portals, tourism boards, airlines, media offices, the embassy network and official social accounts." bodyClassName="p-3" data-id="element-764" data-mp="147vs7171eu19">
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4" data-id="element-765" data-mp="ygatg8djvtwn">
        {states.map(state => {
        const column = placements.filter(placement => placement.state === state.id);
        return <section key={state.id} aria-label={`${state.label} placements`} data-id="element-766" data-mp="oq7r3hkjh3ln">
              <div className="flex items-center justify-between px-1 pb-2" data-id="element-767" data-mp="oo4qy4po9u37">
                <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground" data-id="element-768" data-mp="jr4khsowupbk">
                  {state.label}
                </p>
                <span className="font-mono text-[11px] text-muted-foreground" data-id="element-769" data-mp="aqghru4ywbdz">
                  {column.length}
                </span>
              </div>
              <div className="space-y-2" data-id="element-770" data-mp="5tpualqu2dij">
                {column.length === 0 && <p className="rounded-sm border border-dashed border-border px-2 py-4 text-center text-[11px] text-muted-foreground" data-id="element-771" data-mp="ud4pt8kusc9">
                    None
                  </p>}
                {column.map(placement => {
              const delivery = placement.target ? Math.round(placement.impressions / placement.target * 100) : 0;
              const under = placement.state === 'live' && delivery < 70;
              return <article key={placement.id} className={cn('rounded-sm border px-2.5 py-2', state.className)} data-id="element-772" data-mp="3fmhmyo3w3j14">
                      <p className="text-[12px] font-medium leading-snug" data-id="element-773" data-mp="c8expth0236v">{placement.partner}</p>
                      <p className="text-[11px] text-muted-foreground" data-id="element-774" data-mp="h6geg7qydqf6">{placement.network}</p>
                      <p className="mt-1 text-[11px] text-muted-foreground" data-id="element-775" data-mp="2962yyeb8kjg">
                        {formatDate(placement.scheduledOn)}
                      </p>
                      <div className="mt-1.5 flex items-center justify-between gap-2" data-id="element-776" data-mp="2mzezqs4nyuq6">
                        <span className="font-mono text-[11px]" data-id="element-777" data-mp="2ryro5hb6o9uv">
                          {formatCompact(placement.impressions)} / {formatCompact(placement.target)}
                        </span>
                        <span className={cn('font-mono text-[11px]', under ? 'text-uae-red' : delivery >= 100 ? 'text-uae-leaf' : 'text-muted-foreground')} data-id="element-778" data-mp="152jzjqgcrqdw">
                          {delivery}%
                        </span>
                      </div>
                      <div className="mt-1 h-1 w-full overflow-hidden rounded-full bg-muted" data-id="element-779" data-mp="103qo03kmm9gd">
                        <div className={cn('h-full rounded-full', under ? 'bg-uae-red' : 'bg-uae-green')} style={{
                    width: `${Math.min(delivery, 100)}%`
                  }} data-id="element-780" data-mp="vbytjhycnjky" />
                      </div>
                      {under && <p className="mt-1 text-[10px] text-uae-red" data-id="element-781" data-mp="l9mpp1pmznyu">
                          Below 70% of guarantee — reallocation recommended
                        </p>}
                    </article>;
            })}
              </div>
            </section>;
      })}
      </div>
    </SectionCard>;
}